import { buildEnum } from '@witmetrics/utils/objects';

export const VIEWER_CONTENT_TYPE = buildEnum('NEW', 'FILE', 'FILE_COLLECTION');
